import jQuery from 'jquery';

jQuery(function() {
  // fixes select2 with bootstrap modal conflict
  // http://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal
  if ($.fn.modal) {
    $.fn.modal.Constructor.prototype.enforceFocus = function() {};
  }
});
